// Business data constants for Refúgio Guincho
export const BUSINESS = {
  name: "Refúgio Guincho",
  tagline: "O Menor Preço do Mercado",
  phonePrimary: "(15) 99850-4951",
  phonePrimaryRaw: "+5515998504951",
  phoneSecondary: "(15) 3281-4951",
  phoneSecondaryRaw: "+551532814951",
  whatsappRaw: "5515998504951",
  whatsappMessage: "Olá, preciso de guincho!",
  city: "Araçoiaba da Serra",
  state: "SP",
  address: "Rua Professor Toledo, 167 - Centro",
  instagram: "https://instagram.com/refugioguincho",
  instagramHandle: "@refugioguincho",
  mapsQuery: "Rua Professor Toledo, 167, Centro, Araçoiaba da Serra, SP",
};

export const WHATSAPP_URL = `https://wa.me/${BUSINESS.whatsappRaw}?text=${encodeURIComponent(BUSINESS.whatsappMessage)}`;
export const TEL_PRIMARY = `tel:${BUSINESS.phonePrimaryRaw}`;
export const TEL_SECONDARY = `tel:${BUSINESS.phoneSecondaryRaw}`;

export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_2b86ce22-745d-4dde-8cf6-ccebc44ae1b9/artifacts/r7emby5x_Captura%20de%20Tela%202026-05-06%20a%CC%80s%2012.19.50.png",
  heroTruckRain: "https://customer-assets.emergentagent.com/job_2b86ce22-745d-4dde-8cf6-ccebc44ae1b9/artifacts/1ibmqtx3_Captura%20de%20Tela%202026-05-06%20a%CC%80s%2012.21.11.png",
  porsche: "https://customer-assets.emergentagent.com/job_auto-socorro-sp-2/artifacts/7tzkktjl_Captura%20de%20Tela%202026-05-06%20a%CC%80s%2012.21.29.png",
  streetKombi: "https://customer-assets.emergentagent.com/job_2b86ce22-745d-4dde-8cf6-ccebc44ae1b9/artifacts/izwcwt66_Captura%20de%20Tela%202026-05-06%20a%CC%80s%2012.21.29.png",
  cityRescue: "https://customer-assets.emergentagent.com/job_2b86ce22-745d-4dde-8cf6-ccebc44ae1b9/artifacts/lw6zepos_Captura%20de%20Tela%202026-05-06%20a%CC%80s%2012.21.44.png",
  autoCenter: "https://customer-assets.emergentagent.com/job_auto-socorro-sp-2/artifacts/yxt8j1a5_WhatsApp%20Image%202026-07-07%20at%2015.45.26.jpeg",
  mercedes: "https://customer-assets.emergentagent.com/job_auto-socorro-sp-2/artifacts/ph3v6f8b_Captura%20de%20Tela%202026-05-07%20a%CC%80s%2012.46.15.png",
  audiQ5: "https://customer-assets.emergentagent.com/job_auto-socorro-sp-2/artifacts/nwpak3n0_Captura%20de%20Tela%202026-05-07%20a%CC%80s%2012.46.31.png",
  bugre: "https://customer-assets.emergentagent.com/job_auto-socorro-sp-2/artifacts/8lzo644z_Captura%20de%20Tela%202026-05-07%20a%CC%80s%2012.46.52.png",
  newTruck1: "https://customer-assets.emergentagent.com/job_auto-socorro-sp-2/artifacts/hwxyp2mr_WhatsApp%20Image%202026-07-07%20at%2015.45.27.jpeg",
  newTruck2: "https://customer-assets.emergentagent.com/job_auto-socorro-sp-2/artifacts/c7qv0vh5_WhatsApp%20Image%202026-07-07%20at%2015.45.27-2.jpeg",
  newTruck3: "https://customer-assets.emergentagent.com/job_auto-socorro-sp-2/artifacts/1i845q0k_WhatsApp%20Image%202026-07-07%20at%2015.45.27-3.jpeg",
  newTruck4: "https://customer-assets.emergentagent.com/job_auto-socorro-sp-2/artifacts/oer9nym1_WhatsApp%20Image%202026-07-07%20at%2015.45.27-4.jpeg",
};

export const AREAS = [
  "Araçoiaba da Serra",
  "Sorocaba",
  "Votorantim",
  "São Paulo",
  "Salto de Pirapora",
  "Iperó",
  "Capela do Alto",
  "Alumínio",
  "Mairinque",
  "São Roque",
];
